module.exports = __webpack_public_path__ + "img/yinduQR.a83972a5.jpg";